export const DEFAULT_MAP_CENTER = { latitude: 39.5, longitude: -98.35 };

export const US_MAP_CENTER = { lat: 39.1132688, lng: -104.9799806 };
